// src/components/TariffPage.js
import React from 'react';
import { Helmet } from 'react-helmet';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Container,
} from '@mui/material';

import '../CSS/styles.css'

const TariffPage = () => {
  const standardTariffs = [
    { vehicle: "Sedan", ratePerKm: "2.5", baseFare: "15" },
    { vehicle: "Hatchback", ratePerKm: "2.0", baseFare: "12" },
    { vehicle: "SUV", ratePerKm: "3.0", baseFare: "20" },
  ];

  const premiumTariffs = [
    { vehicle: "Luxury Sedan", ratePerKm: "5.0", baseFare: "30" },
    { vehicle: "Luxury SUV", ratePerKm: "6.0", baseFare: "40" },
  ];

  // Dynamic Car and Package Data
  const touristPlaces = [
    {
      place: "Yercaud",
      distance: "30",
      availableCars: [
        { car: "Sedan", package: "2500" },
        { car: "SUV", package: "3000" },
      ],
    },
    {
      place: "1008 Lingam Temple",
      distance: "15",
      availableCars: [
        { car: "Sedan", package: "1200" },
        { car: "Hatchback", package: "1000" },
        { car: "SUV", package: "1500" },
      ],
    },
    {
      place: "Kottai Mariamman Temple",
      distance: "5",
      availableCars: [
        { car: "Sedan", package: "500" },
        { car: "SUV", package: "700" },
      ],
    },
    {
      place: "Mettur Dam",
      distance: "52",
      availableCars: [
        { car: "Sedan", package: "4000" },
        { car: "Hatchback", package: "3500" },
      ],
    },
  ];

  // Get unique list of cars based on availability (dynamic)
  const uniqueCars = Array.from(
    new Set(touristPlaces.flatMap((place) => place.availableCars.map((car) => car.car)))
  );

  return (
    <Container>
                   <Helmet>
    <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta property="og:type" content="website" />
 <meta property="og:site_name" content="SVR Taxi Service | Call us 9965821750" />
 <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta name="description" content="Reliable, taxi, service, in Salem, and, across India. Available 24/7 with professional drivers and affordable pricing. Book now for a comfortable journey."/>
 <meta name="keywords" content="best cab service in salem ,Salem to Yercaud Taxi Service - Affordable Rides to the Scenic Hill Station,Salem to Tirupati Taxi - Comfortable Rides to the Sacred Temple Town, Salem to Bangalore Taxi Service - Fast and Reliable City Transfers,Salem to Madurai Taxi Service - Explore the Historic City with Ease,Salem to Coimbatore Taxi Service - Quick and Safe Transportation,
Salem to Ooty Taxi Service - Scenic Rides to the Queen of Hill Stations, Salem to Kodaikanal Taxi Service - Travel to the Princess of Hill Stations , Salem to Kanyakumari Taxi Service - Journey to the Southern Tip of India , Salem to Chennai Taxi Service - Efficient Transfers to Tamil Nadu’s Capital , Salem to Oganakkal Falls Taxi Service - Explore the Stunning Waterfalls , Salem to Mettur Dam Taxi Service - Comfortable Rides to the Historic Dam , Salem to Thanjavur Taxi Service - Explore the Cultural Capital of Tamil Nadu ,taxi ,service, Salem, India, airport, transfers, intercity, travel, taxi ,booking,svr taxi,Affordable, taxi ,service ,from ,Salem, to ,Chennai,Best, outstation, cab ,service, from ,Salem ,to ,Kodaikanal,Taxi ,service ,for ,day, trips, in ,and, around, Salem,One-way ,taxi ,service ,from ,Salem ,to ,Bangalore,Book ,a, cab, for ,Salem to ,Tiruchirappalli ,trip,Salem to ,Yercaud ,cab ,service for ,family ,trips,Reliable ,24-hour, taxi, service in Salem,Taxi booking, for airport transfers, in Salem,Safe, taxi, service ,for solo ,women, travelers ,in Salem,Outstation, cab, services ,from Salem ,for business ,trips,Affordable car ,rental ,for Salem, sightseeing,Affordable ,Salem to ,Ooty, weekend, tour ,packages,Salem to ,Munnar, taxi, service with sightseeing packages,Pilgrimage, taxi service from, Salem to ,Samayapuram, Temple,
    Budget ,taxi, packages, from Salem to ,Hogenakkal, Falls,Cab service for Salem to ,Kodaikanal, honeymoon, package,Luxury, taxi service, for ,corporate ,trips, from Salem to ,Chennai,Round-trip, taxi ,service ,from Salem to, Mysore,Car, rental, with, driver, for ,outstation trips, in ,Tamil Nadu,Customized, tour packages, with taxi service in Tamil Nadu,
    Cheap, cab ,service for ,outstation trips, from Salem, best, taxi service in salem , best , taxi , service , Best taxi service in salem , Best Cab service in salem"/>
 <meta name="author" content="SVR Taxi" />
 <link rel="canonical" href="https://svrtaxi.netlify.app/teriff" />
{/* {    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" type="image/x-icon" /> } */}

 <meta property="og:title" content="Easy book taxi in Salem | Taxi Services in Salem" />
 <meta property="og:description" content="Providing safe, reliable, and affordable taxi services in Salem and across India. Book now for a hassle-free experience."/>
 
 <meta property="og:url" content="https://yourwebsite.com"/>
 <link rel="stylesheet" href="%PUBLIC_URL%/styles.css"/>
 <link rel="preconnect" href="https://fonts.googleapis.com"/>
 <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
 <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />

 </Helmet>
      <Typography variant="h4" align="center" gutterBottom class='mt-10'>
        Taxi Tariffs & Tour Packages
      </Typography>

       <Typography variant ="6" align="center "gutterBottom>
       Welcome to our Taxi Tariffs & Tour Packages page, where you can find detailed information about our affordable and premium taxi services. Whether you're traveling locally within Salem or exploring nearby tourist attractions, we offer a range of taxi options to suit your needs.


   </Typography>
   
    
      {/* Standard Tariffs */}
      <Typography variant="h1" gutterBottom class='mt-10' style={{fontSize:'larger'}}>
        Standard Tariffs
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{backgroundColor:'blue',color:'white'}}>
            <TableRow>
              <TableCell>Vehicle Type</TableCell>
              <TableCell>Rate per KM</TableCell>
              <TableCell>Base Fare</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {standardTariffs.map((tariff, index) => (
              <TableRow key={index}>
                <TableCell>{tariff.vehicle}</TableCell>
                <TableCell>{tariff.ratePerKm}</TableCell>
                <TableCell>{tariff.baseFare}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h4" align="center" gutterBottom class='mt-10'>
       Standard Taxi Tariffs
      </Typography >
      <Typography variant="p" align="center" gutterBottom class='mt-10'> 
      Our standard taxi rates are designed to provide an affordable and comfortable travel experience in Salem and beyond. We offer various vehicles including Sedans, Hatchbacks, and SUVs, with competitive rates per kilometer and base fares to ensure a cost-effective journey.


       

Sedan: Perfect for small families or business travel, combining comfort and economy.
Hatchback: Ideal for solo travelers or small groups, offering a budget-friendly option.
SUV: For those seeking a spacious and powerful ride, especially suited for longer journeys.
      </Typography>

      {/* Premium Tariffs */}
      <Typography variant="h1" gutterBottom style={{ marginTop: '20px',fontSize:'larger' }}>
        Premium Tariffs
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{backgroundColor:'blue',color:'white'}}>
            <TableRow>
              <TableCell>Vehicle Type</TableCell>
              <TableCell>Rate per KM</TableCell>
              <TableCell>Base Fare</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {premiumTariffs.map((tariff, index) => (
              <TableRow key={index}>
                <TableCell>{tariff.vehicle}</TableCell>
                <TableCell>{tariff.ratePerKm}</TableCell>
                <TableCell>{tariff.baseFare}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="h1" align="center" gutterBottom sx={{fontSize:'larger'}}>
      Premium Taxi Tariffs
      </Typography>
      <Typography variant="6" align="center" gutterBottom> 
        
For those who prefer a touch of luxury, we also offer premium taxi services. Travel in style with our Luxury Sedans and Luxury SUVs, providing high-end comfort and convenience at reasonable rates.
    
</Typography>

      {/* Famous Temples and Tourist Places */}
      <Typography variant="h1" gutterBottom style={{ marginTop: '20px',fontSize:'larger' }}>
        Famous Temples & Tourist Places (from Salem)
      </Typography>
      <TableContainer component={Paper} sx={{marginBottom:10}}>
        <Table>
          <TableHead sx={{backgroundColor:'blue',color:'white'}}>
            <TableRow>
              <TableCell>Place</TableCell>
              <TableCell>Distance (KM)</TableCell>
              {uniqueCars.map((car) => (
                <TableCell key={car}>{car} Package (INR)</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {touristPlaces.map((place, index) => (
              <TableRow key={index}>
                <TableCell>{place.place}</TableCell>
                <TableCell>{place.distance}</TableCell>
                {uniqueCars.map((car) => {
                  const carPackage = place.availableCars.find((availableCar) => availableCar.car === car);
                  return (
                    <TableCell key={car}>
                      {carPackage ? carPackage.package : "N/A"}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
    </Container>

  );
};

export default TariffPage;
